import * as React from 'react'
import type { SVGProps } from 'react'
const SvgVbx = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={11}
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={3} y={0} width={6} height={1} rx={0.5} fill="currentColor" />
    <path d="M1 2L6 11L11 2L9 2L6 7.5L3 2Z" fill="currentColor" />
  </svg>
)
export default SvgVbx
